import { all, fork } from 'redux-saga/effects';
import { watchDataSaga } from './api/apiSaga';
import {watchSearchFilterSaga} from "./searchAndFilter/searchAndFilterSaga";

export default function* rootSaga() { // Combine all the sagas into a single root saga
    yield all([
        fork(watchDataSaga),
        fork(watchSearchFilterSaga),

    ]);
}
